



































import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})

export default class DeclarationOfConsent extends Vue {
  
  public accept(): void {
    this.$emit('closeModal');
  }
}
